import React, { FC } from 'react';
import { RGBColor } from 'react-color';
import { BadgeWrapper } from './styles';

interface BadgeProps {
  bgColor: RGBColor;
  color: string;
}

const Badge: FC<BadgeProps> = ({ children, bgColor, color }) => (
  <BadgeWrapper r={bgColor.r} g={bgColor.g} b={bgColor.b} color={color}>
    {children}
  </BadgeWrapper>
);

export default Badge;
